// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__tTr9j","col":"CardReaderDesc_col__3KTRq","label":"CardReaderDesc_label__3XyKk"};